import { IInstagramMentionedMediaStats } from '@apis/instagram-mentioned-and-tagged/InstagramMentionedAndTaggedApiModel';
import { IAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';
import { IInstagramSourceAndCountWithAutocomplete } from '@instagram-account/models/IInstagramAutocompleteResponses';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { UniversalSearchSortKey } from '@models/UniversalSearchSortKey';

export interface IInstagramMentionedAndTaggedState {
  autocompleteResults: IInstagramSourceAndCountWithAutocomplete[];
  contentStats: IInstagramMentionedMediaStats;
  dateRange: IAliasedDateRange;
  errors: {
    fetchInstagramMentionedAndTaggedAutocompleteError?: string;
    fetchInstagramMentionedAndTaggedContentError?: string;
    fetchMoreInstagramMentionedAndTaggedContentError?: string;
  };
  flags: {
    isEndOfInstagramMentionedAndTaggedContentReached: boolean;
    isFetchingInstagramMentionedAndTaggedAutocomplete: boolean;
    isFetchingInstagramMentionedAndTaggedContent: boolean;
    isFetchingMoreInstagramMentionedAndTaggedContent: boolean;
  };
  items: IMlsMediaItem[];
  offset: number;
  searchTerms: IInstagramSourceAndCountWithAutocomplete[];
  sort: UniversalSearchSortKey;
  totalMediaCount: number;
}

export const INSTAGRAM_MENTIONED_AND_TAGGED_LIMIT = 50;
